import addClasses from './addClasses.js';
import removeClasses from './removeClasses.js';

var classes = {
  addClasses,
  removeClasses
};

export { classes as default };
